import { gql } from 'apollo-angular';

const UPDATE_CATEGORY_FORMULARY_PRICE = gql`
  mutation UpdateCategoryFormularyPrice(
    $rfpId: Long!
    $formularyPrices: [FormularyPrice!]!
  ) {
    updateCategoryFormularyPrice(
      updateFormularyPriceRequest: { rfpId: $rfpId, prices: $formularyPrices }
    ) {
      id
    }
  }
`;

export default UPDATE_CATEGORY_FORMULARY_PRICE;
